<template>
  <div class="flex flex-col" style="gap: 24px">
    <AppointmentTimeDebuggerFilterBlock
      @checked="onChecked"
    />
    <AppointmentTimeDebuggerResult
      v-if="resultData"
      v-loading="loading"
      :resultData="resultData"
    />
    <EmptyBlock v-else />
  </div>
</template>

<script>
import { useBaseForm } from '@/use/useForm'
import { defineComponent, onBeforeMount, provide, reactive, ref } from 'vue'
import { GetService } from '@/api/service'
import { apiFormatAdaptor } from '@/utils/api'
import { useFetch } from '@/use/fetch'
import { useShop } from '@/use/shop'
import AppointmentTimeDebuggerFilterBlock from './components/AppointmentTimeDebuggerFilterBlock.vue'
import AppointmentTimeDebuggerResult from './components/AppointmentTimeDebuggerResult.vue'

export default defineComponent({
  name: 'AppointmentTimeDebugger',
  components: {
    AppointmentTimeDebuggerFilterBlock,
    AppointmentTimeDebuggerResult,
  },
  setup (props, { emit }) {
    const { formData, formRef, initFormData } = useBaseForm()
    const { fetchAll } = useFetch()
    const { shopId } = useShop()
    const loading = ref(false)
    const resultData = ref(null)

    initFormData({
      service: null,
      subService: null,
      serviceUnit: null,
      serviceResource: null,
      startAt: null,
    })

    const detailData = reactive({
      service: null,
      subService: null,
      serviceUnit: null,
      serviceResource: null,
    })

    const resourceData = reactive({
      service: [],
      subService: [],
      serviceUnit: [],
      attachService: [],
      serviceResource: [],
    })

    const getResources = async () => {
      const callList = [
        async () => {
          await fetchAll(apiFormatAdaptor(GetService), {
            shopId: shopId.value,
          }, (res) => {
            resourceData.service = res
          })
        },
      ]

      await Promise.all(callList.map((call) => call()))
    }

    const onChecked = (data) => {
      resultData.value = data
    }

    provide('formData', formData)
    provide('formRef', formRef)
    provide('resourceData', resourceData)
    provide('detailData', detailData)
    provide('resultData', resultData)
    provide('loading', loading)

    onBeforeMount(() => {
      getResources()
    })

    return {
      loading,
      formData,
      formRef,
      apiFormatAdaptor,
      resourceData,
      onChecked,
      resultData,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
